"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
var useRouter = function () {
    var routerProps = react_1.useContext(react_router_1.__RouterContext);
    return react_1.useMemo(function () {
        var history = routerProps.history, url = routerProps.match.url;
        return __assign({}, routerProps, { pushRoot: function () { return history.push(url); }, rootUrl: function (path) { return (path ? url + "/" + path : url); } });
    }, [routerProps]);
};
exports.default = useRouter;
